import 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}

var us = [
    {
        name: "Alabama",
        iso: 'al',
    },
    {
        name: "Alaska",
        iso: 'ak',
    },
    {
        name: "Arizona",
        iso: 'az',
    },
    {
        name: "Arkansas",
        iso: 'ar',
    },
    {
        name: "California",
        iso: 'ca',
    },
    {
        name: "Colorado",
        iso: 'co',
    },
    {
        name: "Connecticut",
        iso: 'ct',
    },
    {
        name: "Delaware",
        iso: 'de',
    },
    {
        name: "District of Columbia",
        iso: 'dc',
    },
    {
        name: "Florida",
        iso: 'fl',
    },
    {
        name: "Georgia",
        iso: 'ga',
    },
    {
        name: "Hawaii",
        iso: 'hi',
    },
    {
        name: "Idaho",
        iso: 'id',
    },
    {
        name: "Illinois",
        iso: 'il',
    },
    {
        name: "Indiana",
        iso: 'in',
    },
    {
        name: "Iowa",
        iso: 'ia',
    },
    {
        name: "Kansa",
        iso: 'ks',
    },
    {
        name: "Kentucky",
        iso: 'ky',
    },
    {
        name: "Lousiana",
        iso: 'la',
    },
    {
        name: "Maine",
        iso: 'me',
    },
    {
        name: "Maryland",
        iso: 'md',
    },
    {
        name: "Massachusetts",
        iso: 'ma',
    },
    {
        name: "Michigan",
        iso: 'mi',
    },
    {
        name: "Minnesota",
        iso: 'mn',
    },
    {
        name: "Mississippi",
        iso: 'ms',
    },
    {
        name: "Missouri",
        iso: 'mo',
    },
    {
        name: "Montana",
        iso: 'mt',
    },
    {
        name: "Nebraska",
        iso: 'ne',
    },
    {
        name: "Nevada",
        iso: 'nv',
    },
    {
        name: "New Hampshire",
        iso: 'nh',
    },
    {
        name: "New Jersey",
        iso: 'nj',
    },
    {
        name: "New Mexico",
        iso: 'nm',
    },
    {
        name: "New York",
        iso: 'ny',
    },
    {
        name: "North Carolina",
        iso: 'nc',
    },
    {
        name: "North Dakota",
        iso: 'nd',
    },
    {
        name: "Ohio",
        iso: 'oh',
    },
    {
        name: "Oklahoma",
        iso: 'ok',
    },
    {
        name: "Oregon",
        iso: 'or',
    },
    {
        name: "Pennsylvania",
        iso: 'pa',
    },
    {
        name: "Rhode Island",
        iso: 'ri',
    },
    {
        name: "South Carolina",
        iso: 'sc',
    },
    {
        name: "South Dakota",
        iso: 'sd',
    },
    {
        name: "Tennessee",
        iso: 'tn',
    },
    {
        name: "Texas",
        iso: 'tx',
    },
    {
        name: "Utah",
        iso: 'ut',
    },
    {
        name: "Vermont",
        iso: 'vt',
    },
    {
        name: "Virginia",
        iso: 'va',
    },
    {
        name: "Washington",
        iso: 'wa',
    },
    {
        name: "West Virginia",
        iso: 'wv',
    },
    {
        name: "Wisconsin",
        iso: 'wi',
    },
    {
        name: "Wyoming",
        iso: 'wy',
    }
];
var au = [
    {
        name: 'New South Wales',
        iso: 'nsw',
    },
    {
        name: 'Victoria',
        iso: 'vic',
    },
    {
        name: 'Queensland',
        iso: 'qld',
    },
    {
        name: 'South Australia',
        iso: 'sa',
    },
    {
        name: 'Western Australia',
        iso: 'wa',
    },
    {
        name: 'Tasmania',
        iso: 'tas',
    },
    {
        name: 'Australian Capital Territory',
        iso: 'act',
    },
    {
        name: 'Northern Territory',
        iso: 'nt',
    },
];
var statesMap = {
    au: au,
    us: us,
};

var ARStateSelect = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-simple-select',{staticClass:"u-width-100-percent",attrs:{"ar-widget-id":"ar-state-select","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-simple-select","color":_vm.color,"hide-arrow":_vm.hideArrow,"enable-filter":"","enable-clear":_vm.enableClear,"items":_vm.stateItems,"default-select-index":_vm.selectedStateIndex,"placeholder":"Select state...","disabled":_vm.disabled},on:{"select":_vm.handleSelect,"clear":_vm.handleClear}})},
staticRenderFns: [],
  name: 'StateSelect',
  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: null,
    },
    countryIsoCode: {
      type: String,
      default: 'au',
      validator: (val) => ['au', 'us'].indexOf(val) > -1,
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      realVal: this.value,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.realVal};`,
        `country-iso-code=${this.countryIsoCode};`,
      ].join('');
    },
    stateItems() {
      return statesMap[this.countryIsoCode];
    },
    selectedStateIndex() {
      return this.stateItems.findIndex(state => state.name === this.realVal);
    },
  },
  watch: {
    value: {
      handler: function (newVal) {
        this.realVal = newVal;
      },
      immediate: true,
    },
    countryIsoCode() {
      this.realVal = null;
      this.$emit('input', null);
    },
  },
  methods: {
    handleSelect(item, idx) {
      this.realVal = item.name;
      this.$emit('input', this.realVal);
      this.$emit('select', item);
    },
    handleClear() {
      this.$emit('input', null);
      this.$emit('clear');
    },
  },
};

export default ARStateSelect;
